import { flowRight, omit } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { getContext, mapProps } from 'recompose';
import { Field } from 'redux-form';
import listProvider from '../../../list/listProvider';
import Error from '../../../Error';
import Simulation from './Simulation';
import getSettings from '../../../../common/utils/settings';

import './SimulationField.scss';

const SimulationFieldInner = ({
    formGroup: Group,
    items,
    input: { value, ...inputProps },
    meta,
    contractTypeState,
    beneficiaryTypeState,
    rip,
    setIsBeneficiarySign,
    title,
}) => (
    <Group title={title}>
        <div className="simulation-field">
            <div className="head">
                <div />
                <div>Nom de la simulation</div>
                <div>Contrat</div>
                <div>Date de création</div>
                <div>Dernière modification</div>
            </div>
            {items.map((simulation) => (
                <Simulation
                    simulation={simulation}
                    key={simulation.id}
                    checked={value === simulation.id}
                    contractTypeState={contractTypeState}
                    beneficiaryTypeState={beneficiaryTypeState}
                    setIsBeneficiarySign={setIsBeneficiarySign}
                    rip={rip}
                    {...inputProps}
                />
            ))}
        </div>
        <Error {...meta} />
    </Group>
);
SimulationFieldInner.propTypes = {
    formGroup: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    input: PropTypes.shape({
        value: PropTypes.string,
    }).isRequired,
    meta: PropTypes.shape({}).isRequired,
    contractTypeState: PropTypes.shape({}).isRequired,
    beneficiaryTypeState: PropTypes.shape({}),
    rip: PropTypes.shape({}),
    setIsBeneficiarySign: PropTypes.func,
    title: PropTypes.string,
};

SimulationFieldInner.defaultProps = {
    items: [],
};

const SimulationField = flowRight([
    getContext({ formGroup: PropTypes.func.isRequired }),
    listProvider({
        sorts: {
            createdAt: { initialOrder: 'desc', default: true },
            name: { initialOrder: 'asc' },
        },
        name: 'simulation',
        type: 'simulation',
        filter: () => ({ product, data }) => {
            const subscription = getSettings(`simulation.lifeInsurance.types.${data.contractType}.subscription`);

            return ('lifeInsurance' === product
                && data
                && data.contractType
                && subscription !== 'none');
        },
        criteria: ({ rip: { id } }) => ({ ripId: id }),
    }),

    mapProps((props) => ({
        ...omit([
            'load',
            'dispatch',
            'setIsLoading',
            'hasActiveSearch',
        ], props),
        component: SimulationFieldInner,
    })),
])(Field);

export default SimulationField;
